import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ViewerStepInterface } from '../../core';

import styled from './MenuChoiceStepTitle.module.scss';

export interface MenuChoiceStepTitleProps {
  step: ViewerStepInterface;
  isSelect: boolean;
  select: (step: ViewerStepInterface) => void;
}

const MenuChoiceStepTitle: React.FC<MenuChoiceStepTitleProps> = (props) => {
  const [t] = useTranslation();

  return (
    <div
      className={classnames(styled.ff_menu_choice_step_title, {
        [styled.ff_menu_choice_step_title__active]: props.isSelect,
      })}
      data-testid='ff-menu-choice-step-title'
    >
      <div className={styled.ff_menu_choice_step_description}>{t(props.step.id)}</div>
      <div className={styled.ff_menu_choice_step_toggle} onClick={() => props.select(props.step)}>
        {props.isSelect ? t('CLOSE') : t('CUSTOMIZE')}
      </div>
    </div>
  );
};

export default MenuChoiceStepTitle;
